import { bodyScrollHelper } from '../../mixin/bodyScrollHelper'

export default {
  mixins: [bodyScrollHelper],
  props: ['show', 'transparent', 'transparentSm', 'modalContainerClass', 'darkBg', 'padded']
}
